/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Cancelled/view.blocks to change it.
import React from 'react'
import Tysiav2CalendarCancelledIcon from 'DesignSystem/Svgs/Tysiav2CalendarCancelledIcon/index'



/** @type {import('Simple/types.js').View} */
export default function Cancelled({
  children,
  viewPath = "/DesignSystem/AppointmentBookingStateTextWithIcon/StateIcon/Cancelled",
  fill2
  
}) {
  return (<React.Fragment
>
<Tysiav2CalendarCancelledIcon
  viewPath={`${viewPath}/Tysiav2CalendarCancelledIcon`}
 fill2={fill2}
/>
{children}
</React.Fragment>)
}